import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { message } from 'antd';
import { DefaultLoginForm } from 'td-auth-component';
import './Login.css';

import User from '../../../utils/user';

const user = new User();

@inject('userStore') // 如果注入多个store，用数组表示
@observer
class Login extends Component {
  onForgetClick = () => {
    this.props.history.push('/forgetPW');
  };

  onRegisterClick = () => {
    this.props.history.push('/register');
  };

  onValidate = errorString => {
    message.error(errorString);
  };

  onLoginSuccess = accessToken => {
    user.login(accessToken);
    this.props.userStore.getAuthUserInfo();
    this.props.history.replace('/agent/myProject');
  };

  onLoginFail = errorString => {
    message.error(errorString);
  };

  loginTest = async () => {};
  render() {
    return (
      <div className="login-page">
        <div className="content">
          <div className="skew-back">
            <div className="welcome" onClick={this.loginTest}>
              欢迎登录
            </div>
            <DefaultLoginForm
              onForgetClick={this.onForgetClick}
              onRegisterClick={this.onRegisterClick}
              onValidate={this.onValidate}
              onLoginSuccess={this.onLoginSuccess}
              onLoginFail={this.onLoginFail}
              addonBefore={{
                username: <div className="username-addon">+86</div>,
                password: null
              }}
              loginParams={{
                scope: 'read',
                client_id: 'test',
                client_secret: 'test',
                grant_type: 'password',
                // mode: 'test',
                // appVersion: '1.0.0'
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/pages/auth/login/Login.js